import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { offer } from '../data/offer';
const HERO_BG = 'https://cdn.magicpatterns.com/patterns/generated-images/114e7f7c-b720-45ba-a9d4-04559571f636.jpg';
const BUNDLE = 'https://cdn.magicpatterns.com/patterns/generated-images/7c87cbfb-8768-40a4-91ec-b470735828d0.jpg';
interface HeroProps {
  variant: 'stadium' | 'bundle';
}
const rise = {
  hidden: {
    opacity: 0,
    y: 18
  },
  visible: {
    opacity: 1,
    y: 0
  }
};
const ease = [0.23, 1, 0.32, 1] as const;
function TrustRow() {
  return <ul className="flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-white/70" style={{
    paddingTop: "0px",
    paddingBottom: "0px"
  }} data-id="element-81" data-mp="s9gfzxf9kc74">
      <li className="flex items-center gap-2" data-id="element-82" data-mp="3d21rlvg2wgmo">
        <span className="flex" aria-hidden="true" data-id="element-83" data-mp="3d2torapbqmf2">
          {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-sun text-sun" data-id="element-84" data-mp="381e6fqej6u0d" />)}
        </span>
        <span data-id="element-85" data-mp="3j898df6ywfql">
          <span className="font-semibold text-white" data-id="element-86" data-mp="3j9u1d0dmvqmc">{offer.satisfaction}</span> satisfaction
          rate
        </span>
      </li>
      <li className="flex items-center gap-2" data-id="element-87" data-mp="3o5j39ad4ljlt">
        <CheckCircle2Icon className="h-4 w-4 text-celeste-400" aria-hidden="true" data-id="element-88" data-mp="39b4ib4a0404i" />
        {offer.studentCount} students from Bangladesh
      </li>
      <li className="flex items-center gap-2" data-id="element-89" data-mp="3ebisosz2rm5p">
        <CheckCircle2Icon className="h-4 w-4 text-celeste-400" aria-hidden="true" data-id="element-90" data-mp="30hrgfctylo6a" />
        7-day money-back guarantee
      </li>
    </ul>;
}
function HeroCopy({
  centered
}: {
  centered: boolean;
}) {
  return <motion.div initial="hidden" animate="visible" transition={{
    staggerChildren: 0.06
  }} className={centered ? 'max-w-4xl' : 'max-w-xl'} data-id="element-91" data-mp="2qkmune40zuq0">
      <motion.p variants={rise} transition={{
      duration: 0.28,
      ease
    }} className="text-[11px] font-semibold uppercase tracking-[0.22em] text-celeste-400" style={{
      fontSize: "16px",
      paddingTop: "0px",
      paddingBottom: "0px",
      textAlign: "center"
    }} data-id="element-92" data-mp="2vgu2jcfzfgal">
          KODA ☀ DIGITAL
      </motion.p>

      <motion.h1 variants={rise} transition={{
      duration: 0.32,
      ease
    }} className="mt-5 font-display text-[2.15rem] font-extrabold leading-[1.03] tracking-tight text-white sm:text-5xl lg:text-[3.5rem]" data-id="element-93" data-mp="s44i1nkpdlhw">
        <span className="block text-celeste-400" data-id="element-94" data-mp="dd5ews2mzp5p">Two Nations, One Soul:</span>
        <span className="block text-celeste-400" data-id="element-95" data-mp="db2ede3uydmq">The Secret Mindset</span>
        <span className="block text-white" data-id="element-96" data-mp="1b0drfxkntnvk">That Turns Hardship</span>
        <span className="block text-white" style={{
        paddingTop: "0px",
        paddingBottom: "0px"
      }} data-id="element-97" data-mp="161jaz2a60bem">Into World-Class Victory</span>
        <span className="mt-4 block text-[1.3rem] font-bold leading-snug text-celeste-400 sm:text-3xl lg:text-[2rem]" data-id="element-98" data-mp="111ew1gownoqi">
          <span className="block" style={{
          paddingTop: "0px",
          paddingBottom: "0px",
          marginTop: "0px",
          marginBottom: "0px"
        }} data-id="element-99" data-mp="x0ut1whnhqwg">For decades, Argentina and Bangladesh</span>
          <span className="block" data-id="element-100" data-mp="3hqam6y4cdrp9">have fought from the bottom.</span>
        </span>
      </motion.h1>

      <motion.figure variants={rise} transition={{
      duration: 0.32,
      ease
    }} className="mx-auto mt-8 w-full max-w-sm sm:max-w-md lg:max-w-lg" data-id="element-101" data-mp="1xam6ou2m9x0i">
        <img src="https://cdn.magicpatterns.com/uploads/ah33pqoryqeKVaVwdMvVZm/hf_20260830_154133_6afbbf53-f75c-4377-9110-b15e25cc13ac_(1).png" alt="Argentine and Bangladeshi fans marching together in the street, holding both flags under a banner reading Unión y Armonía" className="w-full rounded-xl border border-white/15" style={{
        paddingTop: "0px",
        paddingBottom: "0px",
        marginTop: "0px",
        marginBottom: "0px"
      }} data-id="element-102" data-mp="26a9a1lewpcw7" />
      </motion.figure>

      <motion.p variants={rise} transition={{
      duration: 0.32,
      ease
    }} className="mt-6 max-w-2xl text-lg leading-relaxed text-white/75 sm:text-xl" style={{
      fontSize: "14px",
      paddingTop: "0px",
      paddingBottom: "0px",
      marginTop: "9px",
      marginBottom: "9px",
      width: "328px",
      height: "120px"
    }} data-id="element-103" data-mp="2p1sbhnta8iw4">
        Discover the exact mindset shift that transformed Argentina from poverty to World
        Champions — and how you can apply it to your business, freelance career, or personal
        growth <span className="font-semibold text-white" data-id="element-104" data-mp="3vigoe8dy4hzd">TODAY</span> (even if you&rsquo;ve
        failed before).
      </motion.p>

      <motion.div variants={rise} transition={{
      duration: 0.32,
      ease
    }} className="mt-9" data-id="element-105" data-mp="e91twcf9xt9y">
        <CtaButton size="lg" href="#volumes" label="I want to see all the content." sublabel="Instant Access · 7-Day Money-Back Guarantee" data-id="element-106" data-mp="9b8ohllsp3aq" />
      </motion.div>

      <motion.div variants={rise} transition={{
      duration: 0.32,
      ease
    }} className="mt-9 border-t border-white/10 pt-6" style={{
      paddingTop: "0px",
      paddingBottom: "0px"
    }} data-id="element-107" data-mp="3cryzyg05c8jt">
        <TrustRow data-id="element-108" data-mp="3mp3r6u8umu7h" />
      </motion.div>
    </motion.div>;
}
export function Hero({
  variant
}: HeroProps) {
  if (variant === 'bundle') {
    return <header className="relative overflow-hidden bg-navy-950" data-id="element-109" data-mp="2yxoi8imkhen9">
        <div className="mx-auto grid max-w-content items-center gap-14 px-4 py-20 sm:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:py-28" data-id="element-110" data-mp="2tzmw1otugz7k">
          <HeroCopy centered={false} data-id="element-111" data-mp="19gkk0t64zpja" />
          <div className="relative" data-id="element-112" data-mp="1e9vtz368wmff">
            <img src={BUNDLE} alt="The six volumes of The Argentine Mindset shown as ebook covers and on a tablet" className="relative w-full rounded-2xl border border-white/10 object-cover" data-id="element-113" data-mp="1ea5isnfk0njj" />
          </div>
        </div>
      </header>;
  }
  return <header className="relative isolate overflow-hidden bg-navy-950" data-id="element-114" data-mp="1s959s1qjheiv">
      <img src={HERO_BG} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-80" data-id="element-115" data-mp="1s9y6e9vsanna" />
      <div className="absolute inset-0 bg-navy-950/55" aria-hidden="true" data-id="element-116" data-mp="1x5voakmp4226" />
      <div className="relative mx-auto max-w-content px-4 py-24 sm:px-6 lg:py-32" style={{
      paddingTop: "8px",
      paddingBottom: "8px"
    }} data-id="element-117" data-mp="1j8747f0gcyy6">
        <HeroCopy centered data-id="element-118" data-mp="7tjsas47smf3" />
      </div>
    </header>;
}